import { useQuery } from '@tanstack/react-query';
import { getCRUDItem } from '../services/crudService';

const getMapPopUpsFromDB = async userId => {
  try {
    const { data } = await getCRUDItem({
      entity: 'map_pop_up',
      id: userId,
    });
    return data;
  } catch {
    return null;
  }
};

export const useMapPopUps = (userId, isTabletOrMobile, isMapPage) => {
  return useQuery({
    queryKey: ['mapPopUps'],
    queryFn: () => getMapPopUpsFromDB(userId),
    staleTime: 0,
    enabled: !isTabletOrMobile && !!userId && isMapPage,
    refetchOnWindowFocus: false,
  });
};
